import { FC, useEffect, useState } from 'react'
import { fetchUser } from './utils/api'
import cn from './index.module.css'
import Modal from '@common/Modal'
import Preloader from '@UI/Preloader'
import { CloseOutlined } from '@ant-design/icons'
import { Empty } from 'antd'
import Body from './components/Body/Body'

interface IUpdateSeniorSeminarianSupervision {
  visible: boolean
  userId?: number
  onDismiss: () => void
  onSuccess: (classes: number[], groups: number[]) => void
}

const UpdateSeniorSeminarianSupervision: FC<
  IUpdateSeniorSeminarianSupervision
> = ({ visible, userId, onDismiss, onSuccess }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [user, setUser] = useState<IUser | null>(null)

  const fetchSettings = async () => {
    if (!userId) return
    setIsLoading(true)
    try {
      const user = await fetchUser(userId)
      setUser(user.data)
    } catch (error) {
      console.error('Ошибка при загрузке данных:', error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchSettings()
  }, [visible, userId])

  return (
    <Modal
      active={visible}
      setActive={onDismiss}
      // @ts-ignore
      className={cn.modalWrapper}
    >
      <div className={cn.modalContainer}>
        <div className={cn.modalHeader}>
          <span className={cn.modalHeaderTitle}>Назначить куратора</span>
          <CloseOutlined
            className={cn.closeIcon}
            onClick={onDismiss}
            onPointerEnterCapture={undefined}
            onPointerLeaveCapture={undefined}
          />
        </div>
        {isLoading ? (
          <div className={cn.preloader}>
            <Preloader />
          </div>
        ) : !user && !isLoading ? (
          <div className={cn.stub}>
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={'Такого семинариста нет'}
            />
          </div>
        ) : (
          <Body user={user!} onSuccess={onSuccess} onDismiss={onDismiss} />
        )}
      </div>
    </Modal>
  )
}

export default UpdateSeniorSeminarianSupervision
